import { render } from "./TransactionDetailsModal.vue?vue&type=template&id=6bfcb2f9&scoped=true"
import script from "./TransactionDetailsModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsModal.vue?vue&type=script&lang=js"

import "./TransactionDetailsModal.vue?vue&type=style&index=0&id=6bfcb2f9&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfcb2f9"]])

export default __exports__